module.exports = __webpack_public_path__ + "img/c2facae.jpg";